/**
 * TanStack Query hooks for `geo-breakdown-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	geoBreakdownWidgetQueryKeys,
	type CreateGeoBreakdownWidgetBody,
	type ListGeoBreakdownWidgetResponse,
	type GeoBreakdownWidgetRow,
} from "./api";

export function useGeoBreakdownWidgetList(): UseQueryResult<ListGeoBreakdownWidgetResponse, Error> {
	return useQuery({
		queryKey: geoBreakdownWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function useGeoBreakdownWidgetCreate(): UseMutationResult<GeoBreakdownWidgetRow, Error, CreateGeoBreakdownWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: geoBreakdownWidgetQueryKeys.all });
		},
	});
}

export function useGeoBreakdownWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: geoBreakdownWidgetQueryKeys.all });
		},
	});
}
